// src/pages/Dashboard/Admin/HeuresEnseignement/components/TeachingHoursMatrixTable.jsx

import React from "react";
import { FaCalendarAlt, FaEdit, FaTrash } from "react-icons/fa";

import { formatHours } from "../utils/teachingHoursUtils";

export default function TeachingHoursMatrixTable({
  teachers = [],
  monthSections = [],
  hoursIndex,
  monthlyTotalsByTeacher = {},
  totalsByTeacher = {},
  onEdit,
  onDelete,
  deletingId,
}) {
  return (
    <div className="hidden md:block">
      <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900/60">
        <table className="min-w-[980px] w-full">
          <thead className="sticky top-0 z-20">
            <tr className="bg-slate-50 text-xs uppercase tracking-wide text-slate-600 dark:bg-slate-900 dark:text-slate-300">
              <th className="sticky left-0 z-30 w-44 bg-slate-50 px-4 py-3 text-left font-bold dark:bg-slate-900">
                <div className="flex items-center gap-2">
                  <FaCalendarAlt className="opacity-70" />
                  Semaine
                </div>
              </th>

              {teachers.map((teacher) => (
                <th
                  key={teacher.id}
                  className="min-w-[180px] px-4 py-3 text-left font-bold"
                >
                  {teacher.nom} {teacher.prenom}
                </th>
              ))}
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100 text-sm dark:divide-slate-800">
            {monthSections.map((section) => (
              <React.Fragment key={section.month}>
                <tr className="bg-slate-100/80 dark:bg-slate-800/70">
                  <td
                    colSpan={teachers.length + 1}
                    className="px-4 py-3 text-xs font-bold uppercase tracking-[0.16em] text-slate-600 dark:text-slate-300"
                  >
                    {section.label}
                  </td>
                </tr>

                {section.weeks.map((week) => (
                  <tr
                    key={`${section.month}-${week}`}
                    className="transition hover:bg-slate-50/80 dark:hover:bg-slate-800/40"
                  >
                    <td className="sticky left-0 z-10 bg-white px-4 py-3 font-bold text-slate-800 dark:bg-slate-900 dark:text-slate-100">
                      {week}
                    </td>

                    {teachers.map((teacher) => {
                      const key = `${section.month}__${week}__${teacher.id}`;
                      const entry = hoursIndex.get(key);

                      return (
                        <td key={key} className="px-4 py-3 align-middle">
                          {entry ? (
                            <div className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-slate-50 px-2.5 py-1.5 dark:border-slate-700 dark:bg-slate-800/70">
                              <span className="min-w-8 font-bold text-slate-900 dark:text-white">
                                {formatHours(entry.heures)}
                              </span>

                              <button
                                type="button"
                                onClick={() => onEdit(entry)}
                                className="inline-flex h-7 w-7 items-center justify-center rounded-xl text-slate-500 transition hover:bg-white hover:text-indigo-700 dark:hover:bg-slate-900 dark:hover:text-indigo-300"
                                title="Modifier"
                              >
                                <FaEdit />
                              </button>

                              <button
                                type="button"
                                onClick={() => onDelete(entry)}
                                disabled={deletingId === entry.id}
                                className="inline-flex h-7 w-7 items-center justify-center rounded-xl text-rose-600 transition hover:bg-rose-50 hover:text-rose-700 disabled:opacity-50 dark:hover:bg-rose-500/10"
                                title="Supprimer"
                              >
                                <FaTrash />
                              </button>
                            </div>
                          ) : (
                            <span className="text-slate-300 dark:text-slate-600">
                              —
                            </span>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}

                <tr className="bg-indigo-50/80 dark:bg-indigo-500/10">
                  <td className="sticky left-0 z-10 bg-indigo-50 px-4 py-3 text-xs font-bold uppercase tracking-wide text-indigo-900 dark:bg-slate-900 dark:text-indigo-300">
                    Sous-total
                  </td>

                  {teachers.map((teacher) => (
                    <td
                      key={`subtotal-${section.month}-${teacher.id}`}
                      className="px-4 py-3 text-sm font-bold text-indigo-900 dark:text-indigo-200"
                    >
                      {formatHours(
                        monthlyTotalsByTeacher[
                          `${section.month}__${teacher.id}`
                        ] || 0,
                        true
                      )}
                    </td>
                  ))}
                </tr>
              </React.Fragment>
            ))}
          </tbody>

          <tfoot>
            <tr className="bg-slate-900 text-white">
              <td className="sticky left-0 z-10 bg-slate-900 px-4 py-3 text-xs font-bold uppercase tracking-wide">
                Total
              </td>

              {teachers.map((teacher) => (
                <td key={`total-${teacher.id}`} className="px-4 py-3 text-sm font-bold">
                  {formatHours(totalsByTeacher[String(teacher.id)] || 0, true)}
                </td>
              ))}
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}